.modal-header h1:last-child{margin-top:5px;font-size:1rem;font-weight:400}
/*# sourceMappingURL=send-password.component-H73NNY2X.css.map */
